import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-2xl font-heading text-primary-400">韩漫之家</span>
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              韩国漫画免费阅读首选平台，提供最新最全的韩漫在线资源，涵盖恋爱、奇幻、动作、悬疑等多种类型，让您随时随地享受流畅的阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-categories" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.filter((c) => c.slug !== 'all').slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-quick-links" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">全部漫画</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href="#privacy" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              </li>
              <li>
                <a href="#terms" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-contact" className="hover:text-primary-400 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                <span>contact@hanmanzhijia.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                <span>400-888-6688</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
                <span>北京市朝阳区望京SOHO</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#weibo" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#wechat" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#bilibili" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="哔哩哔哩" rel="nofollow">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {currentYear} 韩漫之家 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <p className="text-xs text-background-400">
            本站所有漫画内容均来自合作伙伴正版授权
          </p>
        </div>
      </div>
    </footer>
  );
}